import { SigningChecklistOrderMutationType } from '@/store/modules/signing-checklist-order/mutation_types'
import { SigningChecklistOrderState } from '@/store/modules/signing-checklist-order/state'

export const mutations: StoreMutations<SigningChecklistOrderMutationType, SigningChecklistOrderState> = {
  SET_SIGNATURE_GROUPS_LOADING_PENDING (state, isPending) {
    state.signatureGroupsLoadingPending = isPending
  },
  SET_SIGNATURE_GROUP_CREATION_PENDING (state, isPending) {
    state.signatureGroupCreationPending = isPending
  },
  SET_SIGNATURE_GROUP_DELETION_PENDING (state, isPending) {
    state.signatureGroupDeletionPending = isPending
  },
  SET_SIGNATURE_GROUP_MOVING_PENDING (state, isPending) {
    state.signatureGroupMovingPending = isPending
  },
  SET_SIGNATURE_GROUPS (state, groups) {
    state.signatureGroups = groups
  },
  SET_SIGNATURE_STEP_DELETION_PENDING (state, isPending) {
    state.signatureStepDeletionPending = isPending
  },
  SET_SIGNATURE_STEP_MOVING_PENDING (state, isPending) {
    state.signatureStepMovingPending = isPending
  },
}
